import * as React from 'react'
import ReactHover, { Hover, Trigger } from 'react-hover'
import { Element, RentList } from './warehouse_rent_list_types'
import ElementInfo from './element_info'
import OverviewCalendarElementColumns from './overview_calendar_element_columns'

interface RentListData extends RentList {
  quantity?: number
}

interface ElementRentListRowProps {
  element: Element
  rentListData: RentListData | null
  startDate: string
  endDate: string
  getRentListsForElement: (element: Element) => RentListData[]
}

function ElementRentListRow({
  element,
  rentListData,
  startDate,
  endDate,
  getRentListsForElement,
}: ElementRentListRowProps): React.ReactElement {
  const totalQty = element.amount || 0
  const availableQty = element.availableQuantity !== undefined ? element.availableQuantity : totalQty

  // Calculate quantities for ElementInfo
  const reservedInCurrentList = rentListData ? rentListData.quantity || 0 : 0
  const allRentLists = getRentListsForElement(element)
  const reservedInOtherLists = allRentLists
    .filter((list) => !rentListData || list.id !== rentListData.id)
    .reduce((sum, list) => sum + (list.quantity || 0), 0)

  return (
    <tr>
      <td className="rent-list-table-element-cell">
        <ReactHover
          options={{
            followCursor: true,
            shiftX: 20,
            shiftY: 0,
          }}
        >
          <Trigger type="trigger">
            <span className={`rent-list-table-element-cell-content ${element.parentId ? 'ml-4' : ''}`}>
              {element.name}
            </span>
          </Trigger>
          <Hover type="hover">
            <ElementInfo
              element={element}
              reservedInCurrentList={reservedInCurrentList}
              reservedInOtherLists={reservedInOtherLists}
            />
          </Hover>
        </ReactHover>
      </td>
      <OverviewCalendarElementColumns
        element={element}
        startDate={startDate}
        endDate={endDate}
        rentListData={rentListData}
      />
    </tr>
  )
}

export default ElementRentListRow
